var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4167 6.70117H19.4283M7.16668 1.45117H18.8333C22.055 1.45117 24.6667 4.06284 24.6667 7.28451V18.9512C24.6667 22.1728 22.055 24.7845 18.8333 24.7845H7.16668C3.94502 24.7845 1.33334 22.1728 1.33334 18.9512V7.28451C1.33334 4.06284 3.94502 1.45117 7.16668 1.45117ZM17.6667 12.3828C17.8107 13.3538 17.6448 14.3454 17.1927 15.2167C16.7406 16.088 16.0253 16.7945 15.1486 17.2358C14.2718 17.6771 13.2782 17.8307 12.3091 17.6748C11.34 17.5188 10.4447 17.0613 9.75066 16.3672C9.05658 15.6731 8.59903 14.7779 8.44309 13.8088C8.28715 12.8397 8.44075 11.846 8.88206 10.9693C9.32336 10.0925 10.0299 9.3772 10.9012 8.92512C11.7724 8.47304 12.7641 8.30719 13.735 8.45117C14.7254 8.59804 15.6423 9.05955 16.3503 9.76753C17.0583 10.4755 17.5198 11.3924 17.6667 12.3828Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.19f59732c6a48204c1c30e02640f85c2.svg";
export { ForwardRef as ReactComponent };